import { forwardRef, memo } from "react";
import { css } from "@emotion/css";
import { Select as SelectAntd } from "antd";

import { useSettingSelector } from "hooks/useSelector";
import "./select.css";

const Select = memo(
  ({
    innerRef,
    custom = false,
    optionsSelect = [],
    selectedColor,
    textDefault,
    ...props
  }) => {
    const settings = useSettingSelector();
    const innerProps = {
      className: `min-w-[190px] text-gray-900 ${
        custom ? `ant-select-selection-${props?.value}` : ""
      } ${
        selectedColor
          ? css`
              div {
                background-color: ${selectedColor}!important;
                color: ${selectedColor
                  ? textDefault
                    ? "black !important"
                    : "white !important"
                  : ""};
              }
              .ant-select-selection-item {
                color: ${settings?.dark_mode && textDefault
                  ? "black !important"
                  : ""};
              }
            `
          : ""
      } ${props?.className}`,
      popupClassName: "p-0",
      ref: innerRef,
      ...props,
    };
    if (optionsSelect) {
      return <SelectAntd {...innerProps}>{optionsSelect}</SelectAntd>;
    }

    return <SelectAntd {...innerProps} />;
  }
);

export default forwardRef((props, ref) => <Select innerRef={ref} {...props} />);
